<!-- <ng-container *ngIf="data">
  <ng-template [ngTemplateOutlet]="template"></ng-template>
</ng-container>

<ng-template #template>
  <a *ngIf="!data">Eigener User wird beim Erstellen verwendet!</a> -->
  <div class="card">
    <div class="card-header card-header-squirrel">
      <h4>Neues Token erstellen</h4>        
    </div>
    
    <div class="card-body">
        <form [formGroup]="userForm" novalidate>
            <hr>
            <h5 *ngIf="data">Benutzer, für den das Token bestimmt ist:</h5>        
            <h5 *ngIf="!data">Token wird für angemeldeten Benutzer erstellt!</h5>        
            <div class="row" *ngIf="data">
                <div class="col-md-12">
                    <mat-form-field class="example-full-width" *ngIf="!isUserSelected">
                        <input matInput placeholder="{{this.translate.data['SEARCHUSER'] | translate}}" formControlName="tokenUser" [matAutocomplete]="auto">

                        <mat-autocomplete #auto="matAutocomplete" [displayWith]="displayFn"
                            (optionSelected)="optionSelected($event)">
                            <mat-option *ngIf="isLoading" class="is-loading">
                                <mat-spinner diameter="50"></mat-spinner>
                            </mat-option>
                            <ng-container *ngIf="!isLoading">
                                <mat-option *ngFor="let user of users" [value]="user">
                                    <span><b>{{ user.userName }}</b> - {{ user.email }}</span>
                                </mat-option>
                            </ng-container>
                        </mat-autocomplete>
                    </mat-form-field>
                    <a class="a-color" *ngIf="isUserSelected && selectedUserName != ''">{{selectedUserName}}</a>
                </div>
            </div>

            <div class="row">
                <a>
                    <button mat-raised-button class="btn btn-squirrel" style="margin-top: 6px;margin-left: 0px"  matTooltip="{{this.translate.data['TOOLTIPCLOSEADDUSERDIALOG'] | translate}}"
                                    (click)="cancel()" >Abbruch</button>
                </a>                                                
                <span style="flex: 1 1 auto"></span>
                <a>
                        <button mat-raised-button class="btn btn-squirrel" style="margin-top: 6px;" matTooltip="Neues Token erstellen"
                                        (click)="add()" >Erstellen</button>
                </a>                   
    
            </div>    
        </form>
    </div>
  </div>
<!-- </ng-template> -->



